function updateCountdownExtraGift(targetInput) {
  const now = new Date().getTime();
  const timeRemaining = targetInput - now;

  const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  document.querySelectorAll(".extra-gift-countdown").forEach(el => el.innerHTML =
    `
        <div class="ext-timer-box"><span class="ext-time-unit">${formattedHours[0]}</span><span class="ext-time-unit">${formattedHours[1]}:</span></div>
        <div class="ext-timer-box"><span class="ext-time-unit">${formattedMinutes[0]}</span><span class="ext-time-unit">${formattedMinutes[1]}:</span></div>
        <div class="ext-timer-box"><span class="ext-time-unit">${formattedSeconds[0]}</span><span class="ext-time-unit">${formattedSeconds[1]}</span></div>
    `)

  if (timeRemaining < 0) {
    document.querySelectorAll(".extra-gift-countdown").forEach(el => el.innerHTML = "00:00:00")
    document.querySelectorAll("#extGiftWithCountdown").forEach(el => el.classList.add('hidden-important'))
    document.querySelectorAll(".gift-item-expanded-ext").forEach(el => el.classList.add('hidden-important'))
    if(intervalExtraGift){
      clearInterval(intervalExtraGift);
    }
  }
}
